import moment from 'moment'

import { MINUTES_STEP } from './constants'

export const getOptions = (currentDate, minDate, maxDate) => {
    const startOfDay = moment(currentDate).startOf('day')

    const result = []

    for (let i = 0; i < 1440 / MINUTES_STEP; i++) {
        const value = moment(startOfDay).add(i * MINUTES_STEP, 'minutes')

        if (minDate && minDate >= value.valueOf()) continue
        if (maxDate && maxDate <= value.valueOf()) continue

        result.push({
            value: value.valueOf(),
            label: value.format('HH:mm'),
        })
    }

    return result
}
